export default [
  {
    type: "FeatureTrack",
    trackId: "GCA_000001405.15_GRCh38_full_analysis_set.refseq_annotation.sorted.gff",
    name: "NCBI RefSeq Genes",
    adapter: {
      type: "Gff3TabixAdapter",
      gffGzLocation: {
        uri: "https://s3.amazonaws.com/jbrowse.org/genomes/GRCh38/ncbi_refseq/GCA_000001405.15_GRCh38_full_analysis_set.refseq_annotation.sorted.gff.gz",
        locationType: "UriLocation"
      },
      index: {
        location: {
          uri: "https://s3.amazonaws.com/jbrowse.org/genomes/GRCh38/ncbi_refseq/GCA_000001405.15_GRCh38_full_analysis_set.refseq_annotation.sorted.gff.gz.tbi",
          locationType: "UriLocation"
        },
        indexType: "TBI"
      }
    },
    textSearching: {
      textSearchAdapter: {
        type: "TrixTextSearchAdapter",
        textSearchAdapterId: "GRCh38-index",
        ixFilePath: {
          uri: "static/jbrowse/trix/GRCh38.ix",
          locationType: "UriLocation"
        },
        ixxFilePath: {
          uri: "static/jbrowse/trix/GRCh38.ixx",
          locationType: "UriLocation"
        },
        metaFilePath: {
          uri: "static/jbrowse/trix/GRCh38_meta.json",
          locationType: "UriLocation"
        },
        assemblyNames: [
          "GRCh38"
        ]
      },
      indexingAttributes: ["Name", "ID"],
      indexingFeatureTypesToExclude: ["CDS", "exon"]
    },
    category: [
      "Genes"
    ],
    assemblyNames: [
      "GRCh38"
    ],
    renderer: {
      type: "SvgFeatureRenderer"
    }
  },
  {
    type: "AlignmentsTrack",
    trackId: "NA12878.alt_bwamem_GRCh38DH.20150826.CEU.exome",
    name: "NA12878 Exome",
    adapter: {
      type: "CramAdapter",
      cramLocation: {
        uri: "https://s3.amazonaws.com/jbrowse.org/genomes/GRCh38/alignments/NA12878/NA12878.alt_bwamem_GRCh38DH.20150826.CEU.exome.cram",
        locationType: "UriLocation"
      },
      craiLocation: {
        uri: "https://s3.amazonaws.com/jbrowse.org/genomes/GRCh38/alignments/NA12878/NA12878.alt_bwamem_GRCh38DH.20150826.CEU.exome.cram.crai",
        locationType: "UriLocation"
      },
      sequenceAdapter: {
        type: "BgzipFastaAdapter",
        fastaLocation: {
          "uri": "https://s3.amazonaws.com/jbrowse.org/genomes/GRCh38/fasta/GRCh38.fa.gz",
          "locationType": "UriLocation"
        },
        faiLocation: {
          uri: "https://s3.amazonaws.com/jbrowse.org/genomes/GRCh38/fasta/GRCh38.fa.gz.fai",
          locationType: "UriLocation"
        },
        gziLocation: {
          uri: "https://s3.amazonaws.com/jbrowse.org/genomes/GRCh38/fasta/GRCh38.fa.gz.gzi",
          locationType: "UriLocation"
        }
      }
    },
    category: [
      "1000 Genomes",
      "Alignments"
    ],
    assemblyNames: [
      "GRCh38"
    ]
  },
  {
    type: "VariantTrack",
    trackId: "ALL.wgs.shapeit2_integrated_snvindels_v2a.GRCh38.27022019.sites.vcf",
    name: "1000 Genomes Variant Calls",
    adapter: {
      type: "VcfTabixAdapter",
      vcfGzLocation: {
        uri: "https://s3.amazonaws.com/jbrowse.org/genomes/GRCh38/variants/ALL.wgs.shapeit2_integrated_snvindels_v2a.GRCh38.27022019.sites.vcf.gz",
        locationType: "UriLocation"
      },
      index: {
        location: {
          uri: "https://s3.amazonaws.com/jbrowse.org/genomes/GRCh38/variants/ALL.wgs.shapeit2_integrated_snvindels_v2a.GRCh38.27022019.sites.vcf.gz.tbi",
          locationType: "UriLocation"
        },
        indexType: "TBI"
      }
    },
    category: [
      "1000 Genomes",
      "Variants"
    ],
    assemblyNames: [
      "GRCh38"
    ]
  },
]



//////////////////
// WEBPACK FOOTER
// ./static/jbrowse/tracks.js
// module id = N4DY
// module chunks = 1